import { useContext } from 'react';
import classNames from 'classnames';
import DashboardContext from '@layouts/DashboardLayout/DashboardContext';
import * as ApiModels from '@typings/api-models';
import CustomLink from '@components/CustomLink';
import { getUrl, IDENTIFIERS } from '@helpers/urlsHelper';
import UserProfileContext from '@layouts/UserProfileLayout/UserProfileContext';
import s from './Workflow.module.scss';

type Props = {
  item: ApiModels.TaskTypedData & {
    userWorkflow:
      | (Pick<ApiModels.UserWorkflow, 'id'> & {
          workflow: Pick<ApiModels.Workflow, 'name'>;
        })
      | null;
  };
};

const Workflow: React.FC<Props> = ({ item }) => {
  const { isInDashboard } = useContext(DashboardContext);
  const { creatorSlug, isInUserProfile } = useContext(UserProfileContext);

  let href;
  if (item.userWorkflow) {
    if (isInDashboard) {
      href = getUrl(IDENTIFIERS.DASHBOARD_USER_WORKFLOW_DETAIL, { userWorkflowId: item.userWorkflow.id });
    } else if (isInUserProfile) {
      href = getUrl(IDENTIFIERS.USER_PROFILE_ACTIVITY_DETAILS, { creatorSlug, userWorkflowId: item.userWorkflow.id });
    }
  }

  return item.userWorkflow
    ? (
      <CustomLink className={classNames('caption', s.link)} to={href} newTab>
        {item.userWorkflow.workflow.name}
      </CustomLink>
    )
    : (
      <>{item.action === 'respond-to-conversation' && <p className="caption">{item.data.lastPurchasedPrice || 'Lead'}</p>}</>
    );
};

export default Workflow;
